import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./whatsapp.module.scss";

// PersonalChannelStatus is the connected-state header for the personal slot.
// The user already saw a QR + status before; this renders the equivalent in
// the new layout without forcing them through the QR component when they're
// already authorized.
const PersonalChannelStatus = ({ channel, onDisconnect }) => {
  const { t } = useTranslation();
  if (!channel) return null;
  return (
    <div className={styles.personalStatus}>
      <div className={styles.personalStatusBadge}>
        <span className={styles.dotConnected} />
        {t("NSWhatsapp.channelConnected")}
      </div>
      {channel.phone && (
        <div className={styles.personalStatusPhone}>{channel.phone}</div>
      )}
      {onDisconnect && (
        <button
          type="button"
          className={styles.channelDisconnect}
          onClick={onDisconnect}
        >
          {t("NSWhatsapp.channelDisconnect")}
        </button>
      )}
    </div>
  );
};

export default PersonalChannelStatus;
